import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthConfigService {
  // URL de redirection par défaut après login
  private defaultPostLoginPath = '/';

  constructor() {}

  /**
   * Retourne le chemin de redirection après login
   * Utilise la configuration de l'environnement ou une valeur par défaut
   */
  getPostLoginRedirectPath(): string {
    return environment.auth.postLoginRedirectPath || this.defaultPostLoginPath;
  }

  /**
   * Stocke l'URL demandée avant redirection vers la page de login
   * pour pouvoir y revenir après authentification
   */
  storeRequestedUrl(url: string): void {
    if (url && url !== '/login') {
      localStorage.setItem('auth_redirect_url', url);
    }
  }

  /**
   * Récupère l'URL demandée avant redirection vers la page de login
   * et la supprime du stockage
   */
  getAndClearRequestedUrl(): string | null {
    const url = localStorage.getItem('auth_redirect_url');
    localStorage.removeItem('auth_redirect_url');
    return url;
  }
}
